<div class="parent-copy">
  <div class="parent-copy__content">
    <app-section-view-copy
      [sectionsContainer]="sectionsContainer()"
      [sourceArtifactId]="sourceArtifactId()"
      [isFieldRequiredFn]="getFieldIsRequired"
    />
  </div>

  <div class="parent-copy__button-container">
    <button
      mat-flat-button
      color="accent"
      (click)="createAndConnectObject()"
      [disabled]="!anyFieldIsSelected || loading()"
    >
      {{ 'TRANS__EDIT_OBJECT_DIALOG__COPY' | translate }}
    </button>

    <button
      mat-button
      color="accent"
      (click)="cancel()"
      [disabled]="loading()"
    >
      {{ 'TRANS__EDIT_OBJECT_DIALOG__CANCEL' | translate }}
    </button>

    @if (loading()) {
      <mat-spinner
        diameter="24"
        mode="indeterminate"
      />
    }
  </div>
</div>
